import { render, staticRenderFns } from "./RenameFolder.vue?vue&type=template&id=85c6d8f6"
import script from "./RenameFolder.vue?vue&type=script&lang=js"
export * from "./RenameFolder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports